import styled from "styled-components";

const StyledColorPickerCard = styled.div`
	.sb-color-picker-card {
		padding: 16px;
		border: 1px solid ${({ theme }) => theme.colors.iron};
		border-radius: 15px;
		min-height: 100px;
		display: flex;
		align-items: center;

		.ant-card-body {
			padding: 0;
			width: 100%;
			display: flex;
			align-items: stretch;
			justify-content: space-between;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				flex-direction: column;
			}
		}

		&__left {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				width: 100%;
				margin-bottom: 16px;
			}

			&__title,
			&__subtitle {
				margin-bottom: 0px;
			}

			&__subtitle {
				font-size: 16px;
			}
			&__current-color {
				margin-top: 16px;
				width: 100%;
				display: flex;
			}
		}

		&__right {
			width: 220px;
			input {
				font-size: 10px !important;
			}
		}
		.sketch-picker {
			box-shadow: none !important;
			border: 1px solid #c8d0dc;
		}
	}

	@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
		&__card {
			.ant-card-body {
				flex-direction: column-reverse;
			}

			&__left {
				width: 100%;
				padding: 16px;

				&__title,
				&__subtitle,
				&__description {
					text-align: center;
				}
			}

			&__right {
				width: 100%;
				margin-bottom: 16px;
				height: 310px;
			}
		}
	}
`;

export default StyledColorPickerCard;

